module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/af48912d019b4f06798ceb5891b0d8e5.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Silver/Silver1.svg
// module id = EC7T
// module chunks = 1